/**
 * 并发缓存
 * @param promiseFn 异步函数
 * 在前端应用中并发请求同一个接口，但只想实际向服务器发起一次请求，并共享这次请求的结果给所有并发的调用者，是一个常见的优化需求，以减少不必要的网络负担和服务器加载。
 */
export default (promiseFn) => {
  let syncApiPromise = null;
  return async () => {
    if (syncApiPromise) {
      return syncApiPromise;
    }
    syncApiPromise = promiseFn(); // 缓存promise实例，也可能是padding状态
    return syncApiPromise;
  };
};
